import { render, staticRenderFns } from "./ChartWalkingWidgetSpeed.vue?vue&type=template&id=6b740252&scoped=true&"
import script from "./ChartWalkingWidgetSpeed.vue?vue&type=script&lang=ts&"
export * from "./ChartWalkingWidgetSpeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b740252",
  null
  
)

export default component.exports